import { useAppSelector } from "../../../store/hooks";
import StudentLiveScreen from "./StudentLiveScreen";
import TutorLiveScreen from "./TutorLiveScreen";

const LiveSession = () => {
  const { user } = useAppSelector((state) => state.store);
  if (["teacher", "admin"].includes(user.role)) return <TutorLiveScreen />;
  return <StudentLiveScreen />;
};

export default LiveSession;
